import React from "react";
import { Navigate, Outlet } from "react-router";
import Wrapper from "../components/Wrapper";
import Home from "../pages/Home/Home";
import Signup from "../pages/Signup/Signup";
import Signin from "../pages/Singin/Signin";
import Promotion from "../pages/Promotion/Promotion";
import ReferCode from "../pages/ReferCode/ReferCode";
import Deposit from "../pages/Deposit/Deposit";
import PromotionDetail from "../pages/Promotion/PromotionDetail";
import BetRecord from "../pages/BetRecord/BetRecord";
import Transaction from "../pages/Transaction/Transaction";
import AllPlatform from "../pages/AllPlatform/AllPlatform";
import Inbox from "../pages/Inbox/Inbox";
import InboxDetail from "../pages/Inbox/InboxDetail";
import Rewards from "../pages/Rewards/Rewards";
import Vip from "../pages/Vip/Vip";
import DownloadApp from "../pages/App/DownloadApp";
import CheckIn from "../pages/CheckIn/CheckIn";
import Authenticator from "./Authenticator";
import GameBox from "../pages/Game/GameBox";
import OverflowHidden from "./OverflowHidden";
import DepositIframe from "../pages/Deposit/DepositIframe";
import Withdraw from "../pages/Withdraw/Withdraw";
import WalletSetting from "../components/SignInUp/components/WalletSetting";
import Settings from "../pages/Settings/Settings";
import Live from "../pages/Live/Live";
import Fish from "../pages/Fish/Fish";
import Arcade from "../pages/Arcade/Arcade";
import RNG from "../pages/RNG/RNG";
import Sports from "../pages/Sports/Sports";
import ForgetPassword from "../pages/ForgetPassword/ForgetPassword";
import ScrollToTop from "./ScrollToTop";
import GameWrap from "../pages/Game/GameWrap";
import DemoTask from "../pages/Task/DemoTask";
import SettingIndex from "../pages/PROFILE_SETTING/settingIndex";
import SimpleProfile from "../pages/Profile/simpleProfile";
import GamePlatformPage from "../pages/gamePlatformPage/GamePlatformPage";
import CasinoGroups from "../pages/CasinoGroups/CasinoGroups";
import SimpleRewards from "../pages/Rewards/simpleRewards";
import SimpleVip from "../pages/Vip/simpleVip";
import VipDetail from "../pages/Vip/components/vipDetail";
import SimpleReferCode from "../pages/ReferCode/simpleReferCode";
import PersonalData from "../pages/Settings/pages/personalData";
import BindIdCard from "../pages/Settings/pages/bindIdCard";
import BindBankAccount from "../pages/Settings/pages/bindBankAccount";
import SetTransactionPassword from "../pages/Settings/pages/setTransactionPassword";
import BindSuccess from "../pages/Settings/pages/bindSuccess";
import ResetPassword from "../pages/Settings/pages/resetPassword";
import ResetPasswordSuccess from "../pages/Settings/pages/resetPasswordSuccess";
import ResetWithdrawPassword from "../pages/Settings/pages/resetWithdrawPassword";
import ResetWithdrawPasswordSuccess from "../pages/Settings/pages/resetWithdrawPasswordSuccess";
import UserSecureVerity from "../pages/Settings/pages/userSecureVerity";
import PointQuery from "../pages/PointQuery/PointQuery";
import DepositSuccess from "../pages/Deposit/DepositSuccess";
import Search from "../pages/Search/search";
import GameSubTypeList from "../pages/gameSubTypeList/gameSubTypeList";
import GameConfirm from "../pages/Game/components/gameConfirm";
import WithdrawSuccess from "../pages/Withdraw/withdrawSuccess";
import Lottery from "../pages/Lottery/Lottery";
import AboutUs from "../components/Rules/AboutUs";
import Privacy from "../components/Rules/Privacy";
import DepositAndWithdraw from "../components/Rules/DepositAndWithdraw";
import GameTeaching from "../components/Rules/GameTeaching";
import CommomProblems from "../components/Rules/CommomProblems";
import ServiceTerms from "../components/Rules/ServiceTerms";
import Responsibility from "../components/Rules/Responsibility";
import Recommend from "../components/Rules/Recommend";
import ServicePage from "../pages/Service/ServicePage";
import Roulette from "../pages/Roulette/roulette";

export const common_route = [
  // {
  //   path: "roulette",
  //   label: "roulette",
  //   element: <Roulette />,
  // },
  {
    path: "forgetpassword",
    label: "forgetpassword",
    element: <ForgetPassword />,
  },
  {
    path: "service-group",
    label: "serviceGroup",
    element: <ServicePage />,
  },

  {
    path: "signup",
    label: "signup",
    element: <Signup />,
  },
  {
    path: "signin",
    label: "signin",
    element: <Signin />,
  },
  {
    path: "deposit",
    label: "deposit",
    element: (
      <Authenticator>
        <Deposit />
      </Authenticator>
    ),
    children: [
      {
        path: "depositfund",
        label: "inbox",
        element: <DepositIframe />,
        profile: true,
      },
      {
        path: "deposit-success",
        label: "deposit-success",
        element: <DepositSuccess />,
      },
    ],
    profile: true,
  },
  {
    path: "betRecord",
    label: "betRecord",
    element: (
      <Authenticator>
        <BetRecord />
      </Authenticator>
    ),
    profile: true,
  },
  {
    path: "transaction",
    label: "transaction",
    element: (
      <Authenticator>
        <Transaction />
      </Authenticator>
    ),
    profile: true,
  },
  {
    path: "AllPlatform",
    label: "AllPlatform",
    element: (
      <Authenticator>
        <AllPlatform />
      </Authenticator>
    ),
  },
  {
    path: "inbox",
    label: "inbox",
    element: (
      <Authenticator>
        <Inbox />
      </Authenticator>
    ),
    children: [
      {
        path: ":inboxId",
        label: "inbox",
        element: <InboxDetail />,
        profile: true,
      },
    ],
    profile: true,
  },
  {
    path: "promotioncontent",
    label: "promotions",
    element: <PromotionDetail />,
  },
  {
    path: "app",
    label: "app",
    element: <DownloadApp />,
  },
  {
    path: "checkin",
    label: "checkin",
    element: <CheckIn />,
  },
  {
    path: "deposit/depositfund",
    label: "depositfund",
    element: <DepositIframe />,
  },
  {
    path: "withdraw",
    label: "withdraw",
    element: (
      <Authenticator>
        <Withdraw />
      </Authenticator>
    ),
    children: [
      {
        path: "withdraw-success",
        label: "withdraw-success",
        element: <WithdrawSuccess />,
      },
    ],

    profile: true,
  },
  {
    path: "data",
    label: "profileData",
    element: (
      <Authenticator>
        <SimpleProfile />
      </Authenticator>
    ),
    profile: true,
    children: [
      {
        path: "point-query/:to?",
        label: "point-query",
        element: (
          <Authenticator>
            <PointQuery />
          </Authenticator>
        ),
      },
    ],
  },

  {
    path: "walletsettings",
    label: "walletsettings",
    element: <WalletSetting />,
  },
  {
    path: "settings",
    label: "settings",
    element: <Settings />,
    children: [
      {
        path: "personal-data",
        label: "personal-data",
        element: (
          <Authenticator>
            <PersonalData />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "bind-id-card",
        label: "bind-id-card",
        element: (
          <Authenticator>
            <BindIdCard />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "bind-bank-account",
        label: "bind-bank-account",
        element: (
          <Authenticator>
            <BindBankAccount />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "bind-transaction-password",
        label: "bind-transaction-password",
        element: (
          <Authenticator>
            <SetTransactionPassword />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "bind-success",
        label: "bind-success",
        element: (
          <Authenticator>
            <BindSuccess />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "reset-password",
        label: "reset-password",
        element: (
          <Authenticator>
            <ResetPassword />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "reset-password-success",
        label: "reset-password-success",
        element: (
          <Authenticator>
            <ResetPasswordSuccess />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "reset-withdraw-password",
        label: "reset-withdraw-password",
        element: (
          <Authenticator>
            <ResetWithdrawPassword />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "reset-withdraw-password-success",
        label: "reset-withdraw-password-success",
        element: (
          <Authenticator>
            <ResetWithdrawPasswordSuccess />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "user-secure-verity",
        label: "user-secure-verity",
        element: <UserSecureVerity />,
        profile: true,
      },
    ],
    profile: true,
  },
  {
    path: "profile/*",
    label: "profile",
    exact: true,
    element: (
      <Authenticator>
        <SettingIndex />
      </Authenticator>
    ),
    profile: true,
  },
  {
    path: "casino-group",
    label: "casino-group",
    element: <CasinoGroups />,
  },
  {
    path: "search",
    label: "search",
    element: <Search />,
    children: [
      {
        path: "game-confirm/:gameName/:to/:gameUid",
        label: "game-confirm",
        element: (
          <>
            <GameConfirm />
            <Outlet />
          </>
        ),
      },
    ],
  },
  {
    path: "rewards",
    label: "rewards",
    element: (
      <Authenticator>
        <SimpleRewards />
      </Authenticator>
    ),
    profile: true,
  },
  {
    path: "refer-code",
    label: "refer-code",
    element: (
      <Authenticator>
        <SimpleReferCode />
      </Authenticator>
    ),
    profile: true,
  },

  {
    path: "vip",
    label: "vip",
    element: (
      <Authenticator>
        <SimpleVip />
      </Authenticator>
    ),
    children: [
      {
        path: ":vipId",
        label: "vip",
        element: <VipDetail />,
        profile: true,
      },
    ],
    profile: true,
  },
  {
    path: "game-confirm/:gameName/:to/:gameUid",
    label: "game-confirm",
    element: (
      <>
        <GameConfirm />
        <Outlet />
      </>
    ),
  },
];

export const routes = [
  {
    path: "/",
    label: "home",
    element: (
      // <div>
      //   <Wrapper>
      //     <ScrollToTop>
      //       <Home TYPE="SLOT" />
      //     </ScrollToTop>
      //   </Wrapper>
      //   <Outlet />
      // </div>
      <Navigate to="/casino" />
    ),
  },
  {
    path: "/promotion",
    label: "promotions",
    element: (
      <Wrapper>
        <Promotion />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/promotion/detail/:promoId",
    label: "promotions",
    element: (
      <Wrapper>
        <ScrollToTop>
          <PromotionDetail />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },

  {
    path: "/refer-code",
    label: "refer-code",
    element: (
      <Wrapper>
        <Authenticator>
          <ScrollToTop>
            <ReferCode />
            <Outlet />
          </ScrollToTop>
        </Authenticator>
      </Wrapper>
    ),
  },
  {
    path: "/rewards",
    label: "rewards",
    element: (
      <Wrapper>
        <Authenticator>
          <Rewards />
          <Outlet />
        </Authenticator>
      </Wrapper>
    ),
  },
  {
    path: "/vip",
    label: "vip",
    element: (
      <Wrapper>
        <Vip />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/task",
    label: "task",
    element: (
      <Wrapper>
        {/* <Task /> */}
        <DemoTask />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/gamebox/:gameName/:to/:gameUid",
    label: "gameBox",
    element: (
      <Authenticator>
        <Wrapper>
          <ScrollToTop>
            {/* <OverflowHidden closePop> */}
            <GameWrap>
              <GameBox />
            </GameWrap>
            <Outlet />
            {/* </OverflowHidden> */}
          </ScrollToTop>
        </Wrapper>
      </Authenticator>
    ),
  },
  {
    path: "/casino",
    label: "casino",
    element: (
      <Wrapper scrollToTop>
        <ScrollToTop>
          <Home />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/live-casino",
    label: "live",
    element: (
      <Wrapper scrollToTop>
        <ScrollToTop>
          <Live />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/fish",
    label: "fish",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Fish />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/egame",
    label: "egame",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Arcade />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/rng",
    label: "rng",
    element: (
      <Wrapper>
        <ScrollToTop>
          <RNG />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/sports",
    label: "sports",
    element: (
      <Wrapper scrollToTop>
        <ScrollToTop>
          <Sports />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/lottery",
    label: "lottery",
    element: (
      <Wrapper scrollToTop>
        <ScrollToTop>
          <Lottery />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/:casinoType/category/:gamePlatform/*",
    label: "gamePlatform",
    element: (
      <Wrapper>
        <ScrollToTop>
          <GamePlatformPage />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },

  {
    path: "/:casinoType/category/:gamePlatform/all",
    label: "gamePlatform",
    element: (
      <Wrapper>
        <ScrollToTop>
          <GamePlatformPage />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/:gameType/category/:gamePlatform/:subType/*",
    label: "gameSubType",
    element: (
      <Wrapper scrollToTop>
        <GameSubTypeList />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/terms/about",
    label: "terms",
    element: (
      <Wrapper scrollToTop>
        <AboutUs />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/terms/private",
    label: "private",
    element: (
      <Wrapper scrollToTop>
        <Privacy />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/terms/deposit-withdraw",
    label: "deposit-withdraw",
    element: (
      <Wrapper scrollToTop>
        <DepositAndWithdraw />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/terms/responsibility",
    label: "responsibility",
    element: (
      <Wrapper scrollToTop>
        <Responsibility />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/terms/service",
    label: "service",
    element: (
      <Wrapper scrollToTop>
        <ServiceTerms />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/terms/faq",
    label: "faq",
    element: (
      <Wrapper scrollToTop>
        <CommomProblems />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/terms/how-to-play",
    label: "how-to-play",
    element: (
      <Wrapper scrollToTop>
        <GameTeaching />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/terms/friend-recommend",
    label: "friend-recommend",
    element: (
      <Wrapper scrollToTop>
        <Recommend />
        <Outlet />
      </Wrapper>
    ),
  },
  // {
  //   path: "/referRule",
  //   label: "ReferRule",
  //   element: (
  //     <Wrapper>
  //       <ReferRule />
  //       <Outlet />
  //     </Wrapper>
  //   ),
  // },
];
